import React, { useState } from 'react';
import { apiDefinitions } from '../utils/apiDefinitions';
import ApiSection from './ApiSection';

import { GrConnect } from "react-icons/gr";
import clsx from 'clsx';
import Tabs_component from 'bwax-ui/components/Tabs';

const ApiDocumentation = () => {
    const [activeTab, setActiveTab] = useState('translations');

    // 获取当前活动标签对应的API类别
    const currentApiCategory = apiDefinitions[activeTab];

    // 准备Tabs组件需要的tabs数据
    const tabsData = Object.keys(apiDefinitions).map(key => ({
        key,
        label: apiDefinitions[key].title,
        content: <ApiSection apiCategory={apiDefinitions[key]} />
    }));

    return (
        <div className="flex flex-col w-full grow pt-[5rem] sm:pt-[7rem] text-[1rem]">
            <div className={clsx(
                "flex flex-col max-w-[56rem] w-full self-center gap-6 px-6 pt-8 pb-16 sm:pt-8",
            )}>
            <h1 className="text-[24px] leading-[1.25] flex items-center gap-3 mb-4">
                <GrConnect />
                API 使用说明
            </h1>
            <div className="px-2">
                <p className="leading-relaxed">
                    有开发能力的用户可以通过调用 HTTP API 来翻译文档，把翻译的动作集成到个人或者企业的工作流程中。                    
                </p>
                <p className="leading-relaxed">
                    目前，调用 API 并不需要支付额外的费用，只是跟网页版一样，翻译文档需要消耗用户的积分。
                </p>
            </div>
            
            <Tabs_component 
                tabs={tabsData} 
                defaultTab="translations"
                onTabChange={(value) => setActiveTab(value)}
                className="w-full"
                // noBorder={true}
            />

            </div>

        </div>
    );
};

export default ApiDocumentation; 